import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    loading: false,
    adhocWidgetData: [], // all active events for the guest — widget browses this anytime
    renderAdhoc: {
        showAdhoc: false,
        adhocData: [],
    },
    error: false,
};

const adhocSlice = createSlice({
    name: 'adhoc',
    initialState,
    reducers: {
        resetAdhoc: () => initialState,
        setAdhocLoading: (state, action) => {
            state.loading = action.payload;
        },
        setAdhocWidgetData: (state, action) => {
            state.adhocWidgetData = action.payload;
        },
        setRenderAdhoc: (state, action) => {
            state.renderAdhoc = {
                showAdhoc: action.payload.showAdhoc,
                adhocData: action.payload.showAdhoc ? action.payload.adhocData : [],
            };
        },
        resetRenderAdhoc: (state) => {
            state.renderAdhoc = initialState.renderAdhoc;
        },
        setAdhocError: (state, action) => {
            state.error = action.payload;
        },
    },
});

export const { resetAdhoc, setAdhocLoading, setAdhocWidgetData, setRenderAdhoc, resetRenderAdhoc, setAdhocError } = adhocSlice.actions;

export default adhocSlice.reducer;